
/**
 * src/web/components/user-details-modal.jsx
 * ユーザアイコンをクリックすると、サムネイルを拡大表示し、
 * そこからお気に入り登録、投稿・月間の日報提出状況の表示ができる。
 */

import React from 'react'
import connect from '../../connects/user-details-modal'
import {
  Button,
  IconButton,
} from 'react-toolbox/lib/button'
import {
  Dialog,
} from 'react-toolbox/lib/dialog'
import DiaryContent from './diary-content'
import favoriteButtonTheme from './themes/favorite-button.css'
import userDetailsTheme from './themes/user-details-modal.css'
import successButtonTheme from './themes/success-button.css'

class UserDetailsModal extends React.Component {

  showUserTimeline = (group_id, user)=> {
    this.props.onClose()
    this.props.showUserTimeline( group_id, user )
  }

  showSummary = ()=> {
    this.props.onClose()
    this.props.showSummary()
  }

  showChatRooms = ()=> {
    this.props.onClose()
    this.props.showChatRooms()
  }

  openChatRoom = (props)=> {
    this.props.openChatRoom(props)
  }

  render() {
    const {
      t,
      user,
      current_user,
      group,
      showUserTimeline,
      onClose,
      showSummary,
      open = false,
      isFavorite,
      isCreating,
      isCreateFailed,
      created,
      toggleFavoriteUser,
      showChatRooms,
      openChatRoom,
      chatMessage,
      individualChatRoom,
    } = this.props

    const is_favorite = user && isFavorite(user, this.props)

    const dialogAction = [
        {label: t('label:日報提出状況'), onClick: ()=> this.showSummary(), raised: true },
        {label: t('label:投稿を見る'), onClick: ()=> this.showUserTimeline( group.group_id, user ), raised: true, primary: true },
        {label: t('label:チャットをする'), onClick: ()=> this.openChatRoom(this.props), disabled: (current_user.user_id != user.user_id) ? false : true ,raised: true, theme: successButtonTheme}
      ]
    
    const chatDialogAction = !individualChatRoom && [{label: t('label:チャットをする'), onClick: ()=> this.openChatRoom(this.props), disabled: (current_user.user_id != user.user_id) ? false : true ,raised: true, theme: successButtonTheme}] || undefined 

    return (
      <Dialog active={open}
        theme={userDetailsTheme}
        avoidKeyboard={false}
        onEscKeyDown={onClose}
        onOverlayClick={onClose}
        actions={chatMessage ? chatDialogAction : dialogAction}>
        <div>
          <div className={userDetailsTheme.rightClose}>
            <IconButton icon='close' onClick={onClose} />
          </div>
          {!chatMessage && current_user.user_id != user.user_id &&
            <div className={userDetailsTheme.rightFollow}>
              <Button className={is_favorite ? 'favorite' : ''} icon={is_favorite ? "flag" : "outlined_flag"} theme={favoriteButtonTheme}
                  label={is_favorite ? t("label:フォロー中") : t("label:フォロー")}
                  onClick={()=> toggleFavoriteUser(user, is_favorite)}/>
            </div>
          }
          <div style={{ textAlign: 'center' }}>
            <img className={userDetailsTheme.userImage} src={ user.icon_image.thumb_url } style={{ alignSelf: 'center', margin: 10, marginTop: 0}} />
            <p style={{ alignSelf: 'center', marginBottom: 5 }}>{user.name}</p>
          </div>
          <div style={{ textAlign: 'center', marginBottom: '10px', padding: '0px' }}>
            <DiaryContent comment content={user.description && user.description || ''} modalContent={true}/>
          </div>
        </div>
      </Dialog>
    )
  }
}

export default connect(UserDetailsModal)
 


// WEBPACK FOOTER //
// ./src/web/components/user-details-modal.jsx